import React, { useEffect, useRef } from "react";

/**
 * A checkbox that can be half-ticked ("some of this group"), for the header of
 * a category or range whose products are picked one by one.
 */
export default function SelectBox({ checked, indeterminate = false, onChange, label, className = "" }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate && !checked;
  }, [indeterminate, checked]);

  return (
    <input
      ref={ref}
      type="checkbox"
      aria-label={label}
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      onClick={(e) => e.stopPropagation()}
      className={`h-4 w-4 shrink-0 rounded border-gray-300 text-primary-600 focus:ring-primary-500 ${className}`}
    />
  );
}
